import styledComponent from 'styled-components';

const StyledSingleCounterLottieIconContainer = styledComponent.div`
  height: 40px;
  @media (min-width: 600px) {
    height: 62px;
  }
`;

export default StyledSingleCounterLottieIconContainer;
